module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fa4d69d8edddf8ec00b0cf01c7ab0261.gif";